import React, { useState, useMemo } from "react";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../modules/auth/firebaseConfig";
import { Link, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import SeoMeta from "../SEO/SeoMeta";
import { Helmet } from "react-helmet-async";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import M2TLogo from "./M2TLogo";
//import FooterLinks from "../LandingPage/FooterLinks";
import { setDoc, doc } from "firebase/firestore";

function M2THeader() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 flex items-center gap-3 bg-[#0B0F19] px-6 py-5 shadow-md">
      <div
        className="flex cursor-pointer items-center gap-2"
        onClick={() => navigate("/")}
        aria-label="Go to homepage"
      >
        <M2TLogo className="h-[1.8rem] sm:h-[2.3rem] md:h-[2.8rem]" />
        {/* <div className="hidden sm:block leading-tight text-left">
          <div className="font-semibold text-lg md:text-2xl text-black">Million2Trillion</div>
          <div className="text-[9px] md:text-xs tracking-wide text-gray-500">
            AI-Powered <span className="text-black/80">Market Network</span>
          </div>
        </div> */}
      </div>
    </header>
  );
}

export default function WaitlistSignup() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    countryOther: "",
    category: "",
    customCategory: "",
    role: "",
    customRole: "",
    subRole: "", // Sub-role field
    note: "",
    agree: false,
    website: "", // honeypot
  });

  const [submitted, setSubmitted] = useState(false);
  const [subRoles, setSubRoles] = useState([]);

  const categoryRoles = {
    Traders: [
      "Forex Trader",
      "Stock Trader",
      "Crypto Trader",
      "Futures Trader",
      "Commodity Trader",
      "Binary Options Trader",
      "Prop Funded Trader",
      "Intraday Trader",
      "Scalper",
      "Swing Trader",
      "Position Trader",
      "Copy Trader",
      "Demo Trader",
    ],
    "Signal Providers": [
      "Forex Signal Provider",
      "Stock Signal Provider",
      "Crypto Signal Provider",
      "Index Signal Provider",
      "Commodity Signal Provider",
      "Binary Signal Provider",
    ],
    "Strategy Experts": [
      "Options Strategist",
      "Scalping Strategy Expert",
      "Swing Setup Publisher",
      "Chart Pattern Specialist",
      "Breakout/Trendline Analyst",
      "Indicator Setup Curator",
      "Live Strategy Host",
    ],
    "Coders & Developers": [
      "EA Developer (MT4/MT5)",
      "Crypto Bot Developer",
      "Pine Script Coder",
      "Custom Indicator Developer",
      "Risk Management Tool Developer",
    ],
    "Automation Experts": [
      "Signal Copy Bot Developer",
      "Backtesting Expert",
      "TradingView Alert Integrator",
      "Automation Workflow Builder",
      "Telegram Bot Creator",
      "Portfolio Tracker Developer",
      "Trading UI/UX Designer",
    ],
    Educators: [
      "Forex Educator",
      "Stock Market Educator",
      "Crypto Educator",
      "Options Strategy Trainer",
      "Technical Analysis Educator",
      "Backtesting Coach",
    ],
    "Mentors & Coaches": [
      "Trading PsyFlogy Coach",
      "Personal Finance Coach",
      "Risk Management Mentor",
      "Scalping Mentor",
      "Swing Trading Mentor",
      "Algo Trading Instructor",
      "Live Room Mentor",
    ],
    Analysts: [
      "Technical Analyst",
      "Fundamental Analyst",
      "Tokenomics Analyst",
      "Economic News Analyst",
      "Options Data Analyst",
      "Volume Profile Analyst",
      "Candlestick Analyst",
      "On-chain Analyst",
      "Quant Analyst",
    ],
    "Finance & Accounting Experts": [
      "Chartered Accountant (CA)",
      "CPA",
      "Tax Specialist",
      "Financial Controller",
      "Business Accountant",
      "Bookkeeper",
      "GST/VAT Expert",
      "Audit & Assurance Consultant",
      "CFO-as-a-Service",
      "Payroll & Compliance Expert",
      "Fund Accountant",
      "Portfolio Bookkeeper",
      "Regulatory Reporting Specialist",
    ],
    Researchers: [
      "Portfolio Researcher",
      "Backtest Reviewer",
      "Sentiment Researcher",
      "Chart Breakdown Writer",
      "Event-Based Strategy Researcher",
    ],
    Investors: [
      "Retail Investor",
      "Long-Term Holder",
      "Angel Investor",
      "Portfolio Manager",
      "Mutual Fund Investor",
      "Index Investor",
      "Copy Investment Allocator",
      "Passive Income Investor",
      "HNI / PAMM / MAM Investor",
      "Strategy Capital Funder",
    ],
    "Influencers & Content Creators": [
      "Forex Influencer",
      "Crypto Influencer",
      "YouTube Educator",
      "Twitter Creator",
      "Reels Creator",
      "Finfluencer",
      "Blog Writer",
      "Newsletter Curator",
      "Visual Designer",
      "Figma UI Designer",
      "Wiki/Knowledgebase Builder",
      "Meme Creator",
    ],
    "Promoters & Marketers": [
      "Affiliate Marketer",
      "Course Reviewer",
      "Podcast Host",
      "Event Host",
      "Resume Builder Promoter",
      "Sponsored Job Marketer",
      "Ad Marketer",
      "Event Promoter",
    ],
    "Brokers & Brokerage Providers": [
      "Broker Representative",
      "White-Label Broker Provider",
    ],
    "Prop Firm Operators": [
      "Prop Firm Owner",
      "Affiliate Manager",
      "Challenge Manager",
      "Lead Verifier",
    ],
    "Platform Providers": [
      "Signal Copy Platform Admin",
      "MT4/MT5 Server Operator",
      "Brokerage Infrastructure Consultant",
    ],
    "Compliance & Regulation Experts": [
      "KYC/AML Officer",
      "Compliance Manager",
      "Regulation Policy Enforcer",
      "Fund Validation Officer",
      "Platform Ethics Consultant",
      "Background Screening Specialist",
    ],
    "Legal Professionals": [
      "Trading Legal Advisor",
      "IP Protection Advisor",
      "Smart Contract Lawyer",
      "Cross-border Legal Consultant",
      "User Dispute Mediator",
      "Legal Audit Advisor",
    ],
    "Tax Experts": [
      "Forex/Crypto Tax Advisor",
      "Global Tax Planner",
      "Options Tax Analyst",
      "Digital Income Specialist",
      "Tax Filing Assistant",
    ],
    "Community Moderators": [
      "Telegram/Discord Manager",
      "Forum Moderator",
      "Feedback Collector",
      "Job Discussion Moderator",
    ],
    "Investment Advisors": [
      "SEBI RIA / PMS Advisor",
      "Robo-Advisory Provider",
      "Financial Planning App Builder",
      "Investment Suitability Analyst",
    ],
    "Capital Fund Providers": [
      "VC Partner",
      "Seed Fund Manager",
      "Institutional Capital Rep",
      "Grant / Program Creator",
      "Investment Banker / M&A Leader",
    ],
    "Career & Job Services": [
      "Resume Builder",
      "Job Platform Owner",
      "Mock Interview Coach",
      "Fintech Headhunter",
    ],
    "Mutual Fund & SIP Providers": [
      "Certified Mutual Fund Distributor",
      "SIP Educator",
      "AMC Representative",
      "Rebalancing Expert",
    ],
    "Carbon Credit & ESG Providers": [
      "ESG Analyst",
      "Carbon Credit Broker",
      "Sustainability Consultant",
      "Net Zero Expert",
    ],
    "Insurance & Risk Providers": [
      "Insurance Advisor",
      "Risk Analyst",
      "Actuary",
      "Reinsurance Specialist",
      "InsurTech Platform Builder",
    ],
    "Crowdfunding & Finance Providers": [
      "Crowdfunding Advisor",
      "Tokenization Consultant",
      "P2P Lending Operator",
      "Microfinance Planner",
      "FX Hedging Advisor",
      "Trade Finance Expert",
    ],
    Others: ["Others"],
  };

  const subRolesOptions = {
    Traders: [
      "Forex Trader",
      "Stock Trader",
      "Crypto Trader",
      "Futures Trader",
      "Commodity Trader",
      "Binary Options Trader",
      "Prop Funded Trader",
      "Intraday Trader",
      "Scalper",
      "Swing Trader",
      "Position Trader",
      "Copy Trader",
      "Demo Trader",
    ],
    "Signal Providers": [
      "Forex Signal Provider",
      "Stock Signal Provider",
      "Crypto Signal Provider",
      "Index Signal Provider",
      "Commodity Signal Provider",
      "Binary Signal Provider",
    ],
    "Strategy Experts": [
      "Options Strategist",
      "Scalping Strategy Expert",
      "Swing Setup Publisher",
      "Chart Pattern Specialist",
      "Breakout/Trendline Analyst",
      "Indicator Setup Curator",
      "Live Strategy Host",
    ],
    "Coders & Developers": [
      "EA Developer (MT4/MT5)",
      "Crypto Bot Developer",
      "Pine Script Coder",
      "Custom Indicator Developer",
      "Risk Management Tool Developer",
    ],
    "Automation Experts": [
      "Signal Copy Bot Developer",
      "Backtesting Expert",
      "TradingView Alert Integrator",
      "Automation Workflow Builder",
      "Telegram Bot Creator",
      "Portfolio Tracker Developer",
      "Trading UI/UX Designer",
    ],
    Educators: [
      "Forex Educator",
      "Stock Market Educator",
      "Crypto Educator",
      "Options Strategy Trainer",
      "Technical Analysis Educator",
      "Backtesting Coach",
    ],
    "Mentors & Coaches": [
      "Trading Psychology Coach",
      "Personal Finance Coach",
      "Risk Management Mentor",
      "Scalping Mentor",
      "Swing Trading Mentor",
      "Algo Trading Instructor",
      "Live Room Mentor",
    ],
    Analysts: [
      "Technical Analyst",
      "Fundamental Analyst",
      "Tokenomics Analyst",
      "Economic News Analyst",
      "Options Data Analyst",
      "Volume Profile Analyst",
      "Candlestick Analyst",
      "On-chain Analyst",
      "Quant Analyst",
    ],
    "Finance & Accounting Experts": [
      "Chartered Accountant (CA)",
      "CPA",
      "Tax Specialist",
      "Financial Controller",
      "Business Accountant",
      "Bookkeeper",
      "GST/VAT Expert",
      "Audit & Assurance Consultant",
      "CFO-as-a-Service",
      "Payroll & Compliance Expert",
      "Fund Accountant",
      "Portfolio Bookkeeper",
      "Regulatory Reporting Specialist",
    ],
    Researchers: [
      "Portfolio Researcher",
      "Backtest Reviewer",
      "Sentiment Researcher",
      "Chart Breakdown Writer",
      "Event-Based Strategy Researcher",
    ],
    Investors: [
      "Retail Investor",
      "Long-Term Holder",
      "Angel Investor",
      "Portfolio Manager",
      "Mutual Fund Investor",
      "Index Investor",
      "Copy Investment Allocator",
      "Passive Income Investor",
      "HNI / PAMM / MAM Investor",
      "Strategy Capital Funder",
    ],
    "Influencers & Content Creators": [
      "Forex Influencer",
      "Crypto Influencer",
      "YouTube Educator",
      "Twitter Creator",
      "Reels Creator",
      "Finfluencer",
      "Blog Writer",
      "Newsletter Curator",
      "Visual Designer",
      "Figma UI Designer",
      "Wiki/Knowledgebase Builder",
      "Meme Creator",
    ],
    "Promoters & Marketers": [
      "Affiliate Marketer",
      "Course Reviewer",
      "Podcast Host",
      "Event Host",
      "Resume Builder Promoter",
      "Sponsored Job Marketer",
      "Ad Marketer",
      "Event Promoter",
    ],
    "Brokers & Brokerage Providers": [
      "Broker Representative",
      "White-Label Broker Provider",
    ],
    "Prop Firm Operators": [
      "Prop Firm Owner",
      "Affiliate Manager",
      "Challenge Manager",
      "Lead Verifier",
    ],
    "Platform Providers": [
      "Signal Copy Platform Admin",
      "MT4/MT5 Server Operator",
      "Brokerage Infrastructure Consultant",
    ],
    "Compliance & Regulation Experts": [
      "KYC/AML Officer",
      "Compliance Manager",
      "Regulation Policy Enforcer",
      "Fund Validation Officer",
      "Platform Ethics Consultant",
      "Background Screening Specialist",
    ],
    "Legal Professionals": [
      "Trading Legal Advisor",
      "IP Protection Advisor",
      "Smart Contract Lawyer",
      "Cross-border Legal Consultant",
      "User Dispute Mediator",
      "Legal Audit Advisor",
    ],
    "Tax Experts": [
      "Forex/Crypto Tax Advisor",
      "Global Tax Planner",
      "Options Tax Analyst",
      "Digital Income Specialist",
      "Tax Filing Assistant",
    ],
    "Community Moderators": [
      "Telegram/Discord Manager",
      "Forum Moderator",
      "Feedback Collector",
      "Job Discussion Moderator",
    ],
    "Investment Advisors": [
      "SEBI RIA / PMS Advisor",
      "Robo-Advisory Provider",
      "Financial Planning App Builder",
      "Investment Suitability Analyst",
    ],
    "Capital Fund Providers": [
      "VC Partner",
      "Seed Fund Manager",
      "Institutional Capital Rep",
      "Grant / Program Creator",
      "Investment Banker / M&A Leader",
    ],
    "Career & Job Services": [
      "Resume Builder",
      "Job Platform Owner",
      "Mock Interview Coach",
      "Fintech Headhunter",
    ],
    "Mutual Fund & SIP Providers": [
      "Certified Mutual Fund Distributor",
      "SIP Educator",
      "AMC Representative",
      "Rebalancing Expert",
    ],
    "Carbon Credit & ESG Providers": [
      "ESG Analyst",
      "Carbon Credit Broker",
      "Sustainability Consultant",
      "Net Zero Expert",
    ],
    "Insurance & Risk Providers": [
      "Insurance Advisor",
      "Risk Analyst",
      "Actuary",
      "Reinsurance Specialist",
      "InsurTech Platform Builder",
    ],
    "Crowdfunding & Finance Providers": [
      "Crowdfunding Advisor",
      "Tokenization Consultant",
      "P2P Lending Operator",
      "Microfinance Planner",
      "FX Hedging Advisor",
      "Trade Finance Expert",
    ],
    Others: ["Others"],
  };

  const categories = Object.keys(categoryRoles);

  const roles = useMemo(() => {
    if (!form.category) return ["Others"];
    const list = categoryRoles[form.category] || ["Others"];
    return list.includes("Others") ? list : [...list, "Others"];
  }, [form.category]);

  const onChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      setForm((f) => ({ ...f, [name]: files[0] })); // store file in state
    } else {
      setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
    }
  };

  const onRoleChange = (e) => {
    const selectedRole = e.target.value;
    setForm({ ...form, role: selectedRole });
    setSubRoles(subRolesOptions[selectedRole] || []); // dynamically update sub-roles
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.agree) return alert("Please agree to the terms.");
    if (form.website) return; // honeypot

    try {
      const email = form.email.trim().toLowerCase();

      // Check if email already exists
      const q = query(collection(db, "waitlist"), where("email", "==", email));
      const snap = await getDocs(q);
      if (!snap.empty) {
        alert("This email is already on the waitlist.");
        return;
      }

      // Check if name + phone already exists
      if (form.phone) {
        const q2 = query(
          collection(db, "waitlist"),
          where("name", "==", form.name.trim()),
          where("phone", "==", form.phone.trim()),
        );
        const snap2 = await getDocs(q2);
        if (!snap2.empty) {
          alert("You’ve already registered with this name and phone number.");
          return;
        }
      }

      // 1. Generate verification token
      const verificationToken = uuidv4();

      // 2. Upload photo to Firebase Storage if exists
      let photoURL = null;
      // if (form.photo) {
      //   const storage = getStorage();
      //   const photoRef = ref(storage, `waitlist-photos/${uuidv4()}-${form.photo.name}`);
      //   await uploadBytes(photoRef, form.photo);
      //   photoURL = await getDownloadURL(photoRef);
      // }

      // 3. Save to Firestore (email as doc ID)
      await setDoc(doc(db, "waitlist", email), {
        name: form.name.trim(),
        email,
        phone: (form.phone || "").trim() || null,
        country:
          form.country === "Others"
            ? (form.countryOther || "").trim()
            : form.country,
        category:
          form.category === "Others"
            ? (form.customCategory || "").trim()
            : form.category,
        role:
          form.role === "Others" ? (form.customRole || "").trim() : form.role,
        subRole: form.subRole || null,
        note: (form.note || "").trim() || null,
        photoURL,
        offer: "3_months_free",
        source: "waitlist_page",
        createdAt: serverTimestamp(),
        status: "new",
        verified: false,
        verificationToken,
      });

      setSubmitted(true);
    } catch (err) {
      console.error("Waitlist submit error:", err);
      alert("Submission failed. Please try again.");
    }
  };

  if (submitted) {
    return (
      <>
        <SeoMeta
          title="Join Million2Trillion Waitlist — 3 Months Free Global Access"
          description="Reserve your spot on Million2Trillion, the world's trusted market network for traders, investors, fund managers, coders, educators, and more. Get 3 months of free verified access at launch — limited spots."
          url="https://million2trillion.com/waitlist"
        />
        <Helmet>
          <title>
            Join Million2Trillion Waitlist — 3 Months Free at Launch
          </title>
          <meta
            name="description"
            content="Unlock your first-mover advantage with Million2Trillion — connect with 100M+ verified financial professionals. Get 3 months free SmartCard access at launch. Join the waitlist today!"
          />
          <meta
            name="robots"
            content="index, follow, max-snippet:-1, max-image-preview:large"
          />
          {/* Open Graph */}
          <meta
            property="og:title"
            content="Million2Trillion Waitlist — Be First to Access the Global Market Hub"
          />
          <meta
            property="og:description"
            content="Join Million2Trillion's early waitlist and unlock premium access to a verified marketplace for traders, investors, coders, and professionals worldwide."
          />
          <meta
            property="og:image"
            content="https://million2trillion.com/assets/og/m2t-waitlist.jpg"
          />
          <meta
            property="og:url"
            content="https://million2trillion.com/waitlist"
          />
          <meta property="og:type" content="website" />
          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Join Million2Trillion Waitlist — 3 Months Free at Launch"
          />
          <meta
            name="twitter:description"
            content="Unlock your first-mover advantage with Million2Trillion — connect, trade, and grow globally. Get 3 months free at launch."
          />
          <meta
            name="twitter:image"
            content="https://million2trillion.com/assets/og/m2t-waitlist.jpg"
          />
        </Helmet>
        <M2THeader />
        <div className="flex min-h-screen items-center justify-center bg-[#0B0F19] px-4 text-black">
          <div className="mx-auto w-full max-w-3xl rounded-lg border border-gray-200 bg-white p-8 text-center shadow-xl">
            <h1 className="mb-2 text-3xl font-bold text-blue-600">
              You’re on the waitlist 🎉
            </h1>
            <p className="text-gray-700">
              We’ve sent a confirmation link to your email.
              <br />
              Please check your inbox and click to verify your early access.
            </p>
            <Link
              to="/"
              className="mt-6 inline-block rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white hover:bg-blue-700"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-[#0B0F19]">
      <SeoMeta
        title="Join Million2Trillion Waitlist — 3 Months Free Global Access"
        description="Reserve your spot on Million2Trillion, the world's trusted market network for traders, investors, fund managers, coders, educators, and more. Get 3 months of free verified access at launch — limited spots."
        url="https://million2trillion.com/waitlist"
      />
      <M2THeader />
      <div className="mx-auto w-full max-w-3xl bg-[#0B0F19] p-4 pb-16 sm:p-8 lg:p-16">
        <div className="mx-auto w-full max-w-3xl rounded-2xl border border-white/10 bg-white/5 p-4 pb-16 sm:p-8 lg:p-16">
          <h1 className="mb-2 text-center text-3xl font-bold text-blue-400">
            Join the Waitlist
          </h1>
          <p className="mb-6 text-center text-sm text-gray-400">
            Unlock{" "}
            <span className="font-semibold text-blue-300">
              3 months free access
            </span>{" "}
            when we launch.
          </p>

          <form onSubmit={submit} className="space-y-3">
            <input
              name="name"
              placeholder="Full Name"
              required
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />
            <input
              name="phone"
              placeholder="Phone (optional)"
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />
            <input
              name="website"
              className="hidden"
              autoComplete="off"
              onChange={onChange}
            />

            <select
              name="country"
              value={form.country}
              onChange={onChange}
              required
              className="w-full rounded border border-gray-600 bg-gray-800 p-3 text-white"
            >
              <option value="">Select Country</option>
              {/* East Asia */}
              <optgroup label="East Asia">
                <option>China</option>
                <option>Japan</option>
                <option>South Korea</option>
                <option>North Korea</option>
                <option>Mongolia</option>
                <option>Taiwan</option>
                <option>Hong Kong</option>
                <option>Macau</option>
              </optgroup>
              {/* Southeast Asia */}
              <optgroup label="Southeast Asia">
                <option>Brunei</option>
                <option>Cambodia</option>
                <option>Indonesia</option>
                <option>Laos</option>
                <option>Malaysia</option>
                <option>Myanmar</option>
                <option>Philippines</option>
                <option>Singapore</option>
                <option>Thailand</option>
                <option>Timor-Leste</option>
                <option>Vietnam</option>
              </optgroup>
              {/* South Asia */}
              <optgroup label="South Asia">
                <option>Afghanistan</option>
                <option>Bangladesh</option>
                <option>Bhutan</option>
                <option>India</option>
                <option>Maldives</option>
                <option>Nepal</option>
                <option>Pakistan</option>
                <option>Sri Lanka</option>
              </optgroup>
              {/* Central Asia */}
              <optgroup label="Central Asia">
                <option>Kazakhstan</option>
                <option>Kyrgyzstan</option>
                <option>Tajikistan</option>
                <option>Turkmenistan</option>
                <option>Uzbekistan</option>
              </optgroup>
              {/* Western Asia / Middle East */}
              <optgroup label="Middle East / Western Asia">
                <option>Armenia</option>
                <option>Azerbaijan</option>
                <option>Bahrain</option>
                <option>Cyprus</option>
                <option>Georgia</option>
                <option>Iran</option>
                <option>Iraq</option>
                <option>Israel</option>
                <option>Jordan</option>
                <option>Kuwait</option>
                <option>Lebanon</option>
                <option>Oman</option>
                <option>Palestine</option>
                <option>Qatar</option>
                <option>Saudi Arabia</option>
                <option>Syria</option>
                <option>Turkey</option>
                <option>United Arab Emirates</option>
                <option>Yemen</option>
              </optgroup>
              {/* North America */}
              <optgroup label="North America">
                <option>United States</option>
                <option>Canada</option>
                <option>Mexico</option>
                <option>Bahamas</option>
                <option>Panama</option>
                <option>Barbados</option>
              </optgroup>
              {/* Central America */}
              <optgroup label="Central America">
                <option>Belize</option>
                <option>Costa Rica</option>
                <option>El Salvador</option>
                <option>Guatemala</option>
                <option>Honduras</option>
                <option>Nicaragua</option>
              </optgroup>
              {/* Caribbean */}
              <optgroup label="Caribbean">
                <option>Cuba</option>
                <option>Dominican Republic</option>
                <option>Haiti</option>
                <option>Jamaica</option>
                <option>Trinidad and Tobago</option>
                <option>Saint Lucia</option>
                <option>Grenada</option>
              </optgroup>
              {/* South America */}
              <optgroup label="South America">
                <option>Argentina</option>
                <option>Bolivia</option>
                <option>Brazil</option>
                <option>Chile</option>
                <option>Colombia</option>
                <option>Ecuador</option>
                <option>Guyana</option>
                <option>Paraguay</option>
                <option>Peru</option>
                <option>Suriname</option>
                <option>Uruguay</option>
                <option>Venezuela</option>
              </optgroup>
              {/* Europe */}
              <optgroup label="Europe">
                <option>Albania</option>
                <option>Andorra</option>
                <option>Austria</option>
                <option>Belarus</option>
                <option>Belgium</option>
                <option>Bosnia and Herzegovina</option>
                <option>Bulgaria</option>
                <option>Croatia</option>
                <option>Czech Republic</option>
                <option>Denmark</option>
                <option>Estonia</option>
                <option>Finland</option>
                <option>France</option>
                <option>Germany</option>
                <option>Greece</option>
                <option>Hungary</option>
                <option>Ireland</option>
                <option>Italy</option>
                <option>Latvia</option>
                <option>Iceland</option>
                <option>Kosovo</option>
                <option>Liechtenstein</option>
                <option>Lithuania</option>
                <option>Luxembourg</option>
                <option>Malta</option>
                <option>Montenegro</option>
                <option>Netherlands</option>
                <option>North Macedonia</option>
                <option>Norway</option>
                <option>Poland</option>
                <option>Portugal</option>
                <option>Romania</option>
                <option>Russia</option>
                <option>Slovakia</option>
                <option>Slovenia</option>
                <option>Spain</option>
                <option>Sweden</option>
                <option>Switzerland</option>
                <option>Ukraine</option>
                <option>United Kingdom</option>
              </optgroup>
              {/* Oceania */}
              <optgroup label="Oceania">
                <option>Australia</option>
                <option>New Zealand</option>
                <option>Fiji</option>
                <option>Papua New Guinea</option>
                <option>Samoa</option>
                <option>Vanuatu</option>
                <option>Tonga</option>
                <option>Solomon Islands</option>
              </optgroup>
              {/* Africa */}
              <optgroup label="Africa">
                <option>Nigeria</option>
                <option>South Africa</option>
                <option>Egypt</option>
                <option>Kenya</option>
                <option>Morocco</option>
                <option>Ghana</option>
                <option>Rwanda</option>
                <option>Tanzania</option>
                <option>Uganda</option>
                <option>Zambia</option>
                <option>Gabon</option>
                <option>Gambia</option>
                <option>Guinea</option>
                <option>Guinea-Bissau</option>
                <option>Ivory Coast</option>
                <option>Lesotho</option>
                <option>Liberia</option>
                <option>Libya</option>
                <option>Niger</option>
                <option>São Tomé and Príncipe</option>
                <option>Senegal</option>
                <option>Seychelles</option>
                <option>Sierra Leone</option>
                <option>Somalia</option>
                <option>South Sudan</option>
                <option>Sudan</option>
                <option>Swaziland (Eswatini)</option>
                <option>Togo</option>
                <option>Tunisia</option>
                <option>Western Sahara</option>
                <option>Zimbabwe</option>
              </optgroup>
              {/* Fallback */}
              <option>Others</option>
            </select>

            {form.country === "Others" && (
              <input
                name="countryOther"
                placeholder="Enter your country"
                required
                className="w-full rounded border border-gray-600 bg-gray-800 p-3"
                onChange={onChange}
              />
            )}

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              <select
                name="category"
                value={form.category}
                onChange={onChange}
                required
                className="w-full rounded border border-gray-600 bg-gray-800 p-3 text-white"
              >
                <option value="">Select Your Category</option>
                {categories.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>

              {form.category === "Others" && (
                <input
                  name="customCategory"
                  placeholder="Enter your Category"
                  required
                  className="w-full rounded border border-gray-600 bg-gray-800 p-3"
                  onChange={onChange}
                />
              )}

              <select
                name="role"
                value={form.role}
                onChange={onRoleChange}
                required
                className="w-full rounded border border-gray-600 bg-gray-800 p-3 text-white"
              >
                <option value="">Select Your Role</option>
                {roles.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>

              {form.role === "Others" && (
                <input
                  name="customRole"
                  placeholder="Enter your Role"
                  required
                  className="w-full rounded border border-gray-600 bg-gray-800 p-3"
                  onChange={onChange}
                />
              )}

              {subRoles.length > 0 && (
                <select
                  name="subRole"
                  value={form.subRole}
                  onChange={onChange}
                  className="w-full rounded border border-gray-600 bg-gray-800 p-3 text-white"
                >
                  <option value="">Select Your Sub-Role (optional)</option>
                  {subRoles.map((sr) => (
                    <option key={sr} value={sr}>
                      {sr}
                    </option>
                  ))}
                </select>
              )}
            </div>

            {/* <div className="w-full">
              <label
                htmlFor="photo"
                className="w-full flex items-center justify-center p-3 bg-gray-800 border border-gray-600 rounded cursor-pointer hover:bg-gray-700 text-white"
              >
                {form.photo ? form.photo.name : "Upload Your Profile Photo (optional)"}
              </label>
              <input
                type="file"
                id="photo"
                name="photo"
                accept="image/*"
                onChange={onChange}
                className="hidden"
              />
            </div> */}

            <textarea
              name="note"
              rows={3}
              placeholder="Tell us what you need (optional)"
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />

            <label className="flex items-start gap-2 text-sm text-gray-300">
              <input
                type="checkbox"
                name="agree"
                checked={form.agree}
                onChange={onChange}
                className="mt-1"
                required
              />
              <span>
                I agree to be contacted by Million2Trillion and accept the{" "}
                <a
                  href="/legal/privacy-policy"
                  className="text-blue-400 underline"
                >
                  Privacy Policy
                </a>
                .
              </span>
            </label>

            <button
              type="submit"
              className="w-full rounded bg-blue-600 py-3 font-semibold text-white hover:bg-blue-900"
            >
              Join Waitlist
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link
              to="/"
              className="text-blue-400 underline hover:text-blue-300"
            >
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
      {/* <FooterLinks /> */}
    </div>
  );
}
